import { CoreStateInterface } from './../interfaces/coreState';
import { Module, MutationTree } from 'vuex';
import { RootStateInterface } from '@/store/rootState';

export const state: CoreStateInterface = {
    hideSidebar: window.innerWidth > 1200 ? false : true,
};

export const mutations: MutationTree<CoreStateInterface> = {
    toggleSidebar(state) { // tslint:disable-line
        state.hideSidebar = !state.hideSidebar;
    },
};

const namespaced: boolean = true;

export const core: Module<CoreStateInterface, RootStateInterface> = {
    namespaced,
    state,
    mutations,
};
